<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item class="style" prop="mpAppidBelong" label="APPID所属">
          <div>
            <el-radio-group v-model="ruleForm.mpAppidBelong">
              <el-radio :label="'0'">服务商公众号APPID</el-radio>
              <el-radio :label="'1'">商家公众号APPID</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item v-if="ruleForm.mpAppidBelong == '0'" label="服务商公众号APPID" prop="mpAppid">
          <div class="style">
            <el-input v-model="ruleForm.mpAppid" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">可选择服务商商户号已绑定的APPID，需为已认证的服务号、政府或媒体类型的订阅号。</p>
        </el-form-item>
        <el-form-item v-if="ruleForm.mpAppidBelong == '1'" label="商家公众号APPID" prop="mpSubAppid">
          <el-input v-model="ruleForm.mpSubAppid" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" label="公众号页面截图" prop="mpPics">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.mpPics.length > 4 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="mpPicsList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return mpPicsSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="style"></div>
              <p class="labels-tips">
                请提供展示商品/服务的页面截图/设计稿（最多5张），若公众号未建设完善或未上线请务必提供。
              </p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mpPicsList: [],
      ruleForm: {
        mpAppidBelong: '0',
        mpAppid: '',
        mpSubAppid: '',
        mpPics: [],
      },
      rules: {
        mpAppidBelong: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        mpAppid: [{ required: true, message: '请输入服务商公众号APPID', trigger: ['blur', 'change'] }],
        mpSubAppid: [{ required: true, message: '请输入商家公众号APPID', trigger: ['blur', 'change'] }],
        mpPics: [{ required: true, message: '请上传公众号页面截图', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = JSON.parse(JSON.stringify(data.businessDataVO));
          let mpPicsList = data.businessDataVO.mpPics.split(',');
          this.mpPicsList = mpPicsList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    mpPicsSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.mpPics.push(file.response.data.url);
      console.log(this.ruleForm.mpPics);
    },
    handleRemove(file, fileList) {
      this.setImgurl(fileList);
    },
    setImgurl(fileList) {
      const result = [];
      for (let item of fileList) {
        console.log(item);
        item.size
          ? result.push({
              url: item.response.data,
            })
          : result.push({
              url: item.url,
            });
      }
      this.ruleForm.mpPics = result;
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
